import React from'react';// This file creates and exports the FlexTable context.
// We use the Context API here because FlexTable needs a good way to parcel out
// information to each of its subcomponents.  This allows us to easily share props
// across different modules without pulling in Redux.
// See: https://blog.logrocket.com/how-and-when-to-use-reacts-new-context-api-b584e41b2704/
var FlexTableContext=React.createContext();export default FlexTableContext;